// extracted by mini-css-extract-plugin
export default {"title-section":"fX2jlfukC+","titleSection":"fX2jlfukC+","table":"QatQK84Y1Z","status":"kFJDhLjxEn"};